import { render, staticRenderFns } from "./CaseJewellersTour.vue?vue&type=template&id=718a5afd"
import script from "./CaseJewellersTour.vue?vue&type=script&lang=js"
export * from "./CaseJewellersTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports